export const APP_FILE_ACCOUNTING_DASHBOARD =  "/accounting-dashboard";
export const APP_FILE_ACCOUNTING_INVOICE_INFORMATION_LIST =  "/invoices-list";
export const APP_FILE_ACCOUNTING_INVOICE_TRANSACTION_LIST =  "/invoice-transactions-list";
export const APP_FILE_ACCOUNTING_INVOICE_INFORMATION =  "/invoices/create";
export const APP_FILE_ACCOUNTING_PAYMENT_LIST =  "/invoice-payment-list";
export const APP_FILE_INVOICE_PAYMENT_HISTORY_WRAPPER =  "/invoices/payment/history";
export const APP_FILE_ACCOUNTING_COMPANY =  "/company";
export const APP_FILE_ACCOUNTING_COMPANY_DETAIL =  "/company-detail";
export const APP_FILE_ACCOUNTING_COMPANY_ONBOARDING =  "/company-onboarding";
export const APP_FILE_ACCOUNTING_BILL_LIST=  "/bill-list";
export const APP_FILE_ACCOUNTING_BILL =  "/bill/create";
export const APP_FILE_CHART_OF_ACCOUNT_LIST =  "/chart-account-list";
export const APP_FILE_CHART_OF_ACCOUNT =  "/chart-account";
export const APP_FILE_ACCOUNTING_BANK_ACCOUNT_LIST =  "/bank-account-list";
export const APP_FILE_ACCOUNTING_BANK_ACCOUNT =  "/bank-account";
export const APP_FILE_ACCOUNTING_CREDIT_CARD_LIST =  "/credit-card-list";
export const APP_FILE_ACCOUNTING_CREDIT_CARD =  "/credit-card";
export const APP_FILE_ACCOUNTING_CHEQUE_LIST =  "/cheque-list";
export const APP_FILE_ACCOUNTING_CHEQUE =  "/cheque";
export const APP_FILE_GENERAL_LEDGER_LIST =  "/reports/general-ledger";
export const APP_FILE_GL_SUMMARY =  "/reports/gl-summary";
export const APP_FILE_GL_DETAIL =  "/reports/gl-detail";
export const APP_FILE_CUSTOMER_STATEMENT = "/customer-statement";
export const APP_FILE_SALES_COMMISSION_TAB = "/sales-and-commission-report";
export const APP_FILE_INSURANCE_REMITTANCE = "/reports/insurance-remittance";
export const APP_FILE_AGED_INSURER_PAYABLE = "/reports/aged-insurer-payables";
export const APP_FILE_ACCOUNT_PAYABLE_REPORT = "/reports/account-payable-reports";
export const APP_FILE_TAX_LIST = "/tax";
export const APP_FILE_ACCOUNTING_TAX_INFO = "/tax-info";
export const APP_FILE_GL_ACCOUNT_TAB = "/accounting/settings";
export const APP_FILE_INVOICE_TEMPLATE = "/invoice-template";
export const APP_FILE_INVOICE_PAYMENT_WRAPPER = "/create-payment";
export const APP_FILE_INVOICE_BULK_PAYMENT_WRAPPER = "/create-bulk-payment";
export const APP_FILE_BULK_INVOICES = "/create-bulk-invoices";
export const APP_FILE_BULK_BILLS = "/create-bulk-bills";
export const APP_FILE_PAYMENT_VIEW = "/create-payment/view";
export const APP_FILE_TAX_REPORT = "/reports/tax-report";
export const APP_FILE_ACCOUNTING_TRANSACTION_TYPES_LIST = "/transaction-type-list";
export const APP_FILE_INVOICE_TRANSACTION_TYPE = "/create-transaction-type";
export const APP_FILE_ACCOUNTING_TRANSACTION_DESCRIPTION_LIST = "/transaction-description-list";
export const APP_FILE_INVOICE_TRANSACTION_DESCRIPTION = "/create-transaction-description";
export const APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE_LIST = "/bill-payment-list";
export const APP_FILE_ACCOUNTING_BILL_PAYMENT_PAYABLE = "/bill/payment/create";
export const APP_FILE_BILL_PAYMENT_PAYABLE_VIEW = "/bill/payment/create";
export const APP_FILE_BILL_PAYMENT_PAYABLE_BULK_CREATE = "/bill/payment/bulk-create";
export const APP_FILE_BILL_TEMPLATE = "/bill-template";
export const APP_FILE_ACCOUNTING_VENDOR_LIST = "/vendor/list";
export const APP_FILE_ACCOUNTING_VENDOR = "/vendor/create";

export const APP_FILE_ACCOUNTING_BILL_TRANSACTION_TYPES_LIST = "/bill-transaction-type-list";
export const APP_FILE_BILL_TRANSACTION_TYPE = "/bill-transaction-type/manage";

export const APP_FILE_RECURRING_INVOICES_LIST = "/recurring-invoices-list";
export const APP_FILE_CREATE_RECURRING_INVOICE = "/create-recurring-invoice";
